<template>
  <v-layout row wrap align-content-start fill-height class="pa-4">
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-text>
          <span class="headline">Add Examination</span>
          <v-container grid-list-md>
            <v-form ref="form" lazy-validation>
              <v-layout wrap >
                <v-flex xs12>
                  <label v-bind:style="{ display: accNoLabel, color: 'red' }">* Required</label>
                  <v-text-field 
                    v-model="editedItem.accNo"
                    label="Examination Record">
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <label v-bind:style="{ display: patientIDLabel, color: 'red' }">* Required</label>
                  <v-autocomplete
                    class="owl-carousel"
                    label="Patient"
                    :items="getPatients"
                    v-model="patientSelected" 
                    item-text="name"
                    item-value="id"
                    persistent-hint
                    return-object
                    v-on:change="setExaminationPatientID">
                  </v-autocomplete>
                <div v-show="patientSelected.no != '' " class="hint"> 
                  <p>Medical Record: <b>{{patientSelected.no}}</b> Birthdate: <b>{{patientSelected.birthday}}</b> Gender: <b>{{genderFormated[patientSelected.gender]}}</b> </p>
                </div >      
                </v-flex>
                <v-flex xs12>
                  <label v-bind:style="{ display: dateLabel, color: 'red' }">* Required</label>
                  <v-menu
                    :close-on-content-click="true"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width>
                      <v-text-field
                        slot="activator"
                        label="Date"
                        persistent-hint
                        prepend-icon="event"
                        readonly
                        :value="editedItem.date">
                      </v-text-field>
                    <v-date-picker v-model="editedItem.date" no-title></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12>
                  <label v-bind:style="{ display: orderDoctorIDLabel, color: 'red' }">* Required</label>
                  <v-select 
                    label="Order Doctor"
                    :items="getDoctorsListFormat"
                    v-model="editedItem.orderDoctorID">
                  </v-select>
                </v-flex>

                <v-flex xs12>
                  <label v-bind:style="{ display: examination_typeIDLabel, color: 'red' }">* Required</label>
                  <v-select
                    label="Examination Type"
                    :items="getExaminationTypesListFormat"
                    v-model="editedItem.examination_typeID">
                  </v-select>
                </v-flex>

              </v-layout>                  
            </v-form>
            <v-chip class="err-msg" v-if="errorMessage" color="red" text-color="white">
              <v-icon left>info</v-icon>
              {{ errorMessage }}
            </v-chip>
          </v-container>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click="addExamination">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-flex xs12 class="page-head-container mb-3">
      <v-flex xs12 class="mb-4 page-head-container">
        <h1 class="headline font-weight-light">
          Examination List
        </h1>
      </v-flex>

      <v-flex xs12 class="search-container">
        <v-layout>
          <v-flex xs2>
            <h4>Examination Record</h4>
            <v-text-field
              v-model="condition.accNo"
              :rules="XssRules"
              hide-details 
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <h4>Doctor Name</h4>
            <search-doctor-input
              @selected="updateDoctor"
              :name="condition.orderDoctorID"
            ></search-doctor-input>
          </v-flex>
          <v-flex xs2>
            <h4>Patient Name</h4>
            <search-patient-input
              @selected="updatePatient"
              :name="condition.patientID"
            ></search-patient-input>
          </v-flex>
          <v-flex xs2>
            <h4>Start Date</h4>
            <date-picker-input
              :date="condition.st"
              @selected="(date) => updateDate(date, 'st')"
            ></date-picker-input>
          </v-flex>
          <v-flex xs2>
            <h4>End Date</h4>
            <date-picker-input
              :date="condition.et"
              @selected="(date) => updateDate(date, 'et')"
            ></date-picker-input>
          </v-flex>
          <v-flex xs1>
            <v-btn 
              @click="resetSearch()">
                Reset
            </v-btn>
          </v-flex>
          <v-flex xs1>
            <v-btn
              elevation="2"
              color="info"
              @click="search"
            > Search
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12>
        <template>
          <v-data-table
            v-if="getExaminationSearchResult.length > 0"
            :headers="headers"
            :items="getExaminationSearchResult"
            :pagination.sync="pagination"
            hide-actions
            class="my-4"
            :disable-initial-sort=true>

            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in headers"
                  :key="header.text"
                  :class="['column sortable', pagination.order ? 'desc' : 'asc', header.value === pagination.title ? 'active' : '']"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>


            <template slot="items" slot-scope="props">
              <tr @click="clickItem(props.item)">
                <td>
                  <v-edit-dialog
                    :return-value.sync="props.item.examination"
                    lazy
                    @save="updateExamination(props.item.id, 'accNo', tempItem.accNo)"
                  > {{ props.item.accNo }}
                    <v-text-field
                      slot="input"
                      v-model="tempItem.accNo"
                      label="Edit"
                      single-line
                    ></v-text-field>
                  </v-edit-dialog>
                </td>
                
                <td>
                  <v-autocomplete
                    :items="getPatientsListFormat"
                    v-model="props.item.patientID" 
                    @change="updateExamination(props.item.id,'patientID',$event) ">
                  </v-autocomplete>
                </td>
                <td v-if="dateMenus !== null">

                  <v-menu
                    v-model="dateMenus[props.index]"
                    :nudge-right="40"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <div slot="activator">
                      {{ props.item.date }}
                    </div>
                    <v-date-picker v-model="props.item.date" no-title @change="updateExamination(props.item.id,'date',props.item.date)"></v-date-picker>
                  </v-menu>

                </td>
                <td>
                  <v-select
                      label="Doctor"
                      :items="getDoctorsListFormat"
                      v-model="props.item.orderDoctorID"
                      @change="updateExamination(props.item.id,'orderDoctorID',$event)">>
                    </v-select>
                </td>
                <td>
                  <v-select
                    :items="getExaminationTypesListFormat"
                    v-model="props.item.examination_typeID" 
                    @change="updateExamination(props.item.id,'examination_typeID',$event)">
                  </v-select>
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>

        <div class="text-center">
          <v-pagination
            v-model="getExaminationSearchInfo.page"
            :length="getExaminationSearchInfo.total_page"
            :total-visible="7"
            @input="clickPage"
          ></v-pagination>
        </div>

      </v-flex>
    </v-flex>

    <v-btn icon fixed bottom right fab color="primary" @click="clickAddExamination">
      <v-icon>add</v-icon>
    </v-btn>

    <v-snackbar
      v-model="snackbar"
      bottom
      :timeout="timeout"
      color="red"
    >
      {{ message }}
    </v-snackbar>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import common from '../../utils/common'
  import SearchDoctorInput from './components/SearchDoctorInput.vue';
  import SearchPatientInput from './components/SearchPatientInput.vue';
  import DatePickerInput from './components/DatePickerInput.vue';

  const today = new Date().toISOString().substr(0,10);
  const twoWeeksAgo = common.getDateCompareToToday(-14)

  export default {
    components: { 
      SearchDoctorInput,
      SearchPatientInput,
      DatePickerInput
    },
    name: 'AdminExaminationList',
    watch: {
      dialog() {
        this.editedItem.accNo = ''
        this.editedItem.patientID = ''
        this.editedItem.date = today;
        this.editedItem.orderDoctorID = ''
        this.editedItem.examination_typeID = ''
        this.$refs.form.resetValidation()
        this.errorMessage = null
      }
    },
    data() {
      return {
        genderFormated: {
          1: 'Male',
          0: 'Female'
        },
        patientSelected: { name: '', no: '', id: '', birthday: '', gender: '' },
        pagination: {
          rowsPerPage: -1,
          title:'',
          order:false
        },
        headers: [
          {
            text: 'Examination Record',
            align: 'left',
            value: 'accNo',
            // sortable: false
          },
          {
            text: 'Patient',
            align: 'left',
            value: 'patientID',
            sortable: false
          },
          {
            text: 'Date',
            align: 'left',
            value: 'date',
            sortable: false
          },
          {
            text: 'Order Doctor',
            align: 'left',
            value: 'orderDoctorID',
            sortable: false
          },
          {
            text: 'Examination Type',
            align: 'left',
            value: 'examination_typeID',
            sortable: false
          }
        ],
        message: null,
        snackbar: false,
        timeout: 3000,
        tempItem:'',
        tempValue:'',
        dateMenus:null,
        errorMessage: null,
        editedItem: {
          accNo : '',
          patientID : '',
          date : today,
          orderDoctorID : '',
          examination_typeID : ''
        },
        dialog: false,
        accNoLabel: 'none',
        patientIDLabel: 'none',
        dateLabel: 'none',
        orderDoctorIDLabel: 'none',
        examination_typeIDLabel: 'none',
        condition: {
          page: 1,
          pgsz: 100,
          st: twoWeeksAgo, // startDate.. search last 2 weeks's result
          et: today, // endDate
          accNo: null, 
          patientID: null, 
          orderDoctorID: null
        },
        XssRules: [
          value => {
            if ( this.condition.accNo == null){
              return this.condition.accNo = ''
            } else { 
              let xssFilter = new RegExp(/(\b)(on\S+)(\s*)=|javascript|(<\s*)(\/*)script/ig)
              this.condition.accNo = this.condition.accNo.replace(/[&><%^&"]/g, '')
              this.condition.accNo = (xssFilter.test(this.condition.accNo)) ? this.condition.accNo = '' : this.condition.accNo
              return true
            } 
        }],             
      }
    },

    computed: {
      ...mapGetters('examinations', [
        'getExaminationSearchResult',
        'getExaminationSearchInfo',
        'getExaminationInfos'
      ]),
      ...mapGetters('patients', [
        'getPatientsListFormat',
        'getPatients',
      ]),
      ...mapGetters('examinationTypes', ['getExaminationTypesListFormat']),
      ...mapGetters('doctors', ['getDoctorsListFormat']),
    },

    created () {
      this.search()
      this.fetchPatients()
      this.fetchExaminationTypes()
      this.fetchDoctors()
    },
    mounted(){

    },

    methods: {
      ...mapActions('examinations', ['fetchExaminationInfos', 'searchExaminations']),
      ...mapActions('examinationTypes', ['fetchExaminationTypes']),
      ...mapActions('patients', ['fetchPatients']),
      ...mapActions('doctors', ['fetchDoctors']),
      setExaminationPatientID (item) {
        this.editedItem.patientID = item.id
      },
      search () {
        this.searchExaminations(this.condition).then(() => {
          this.initDate()
        })
      },
      clickPage (page) {
        this.condition.page = page
        this.search()
      },
      updatePatient(info) {
        this.condition.patientID = info ? info.id.toString() : null
      },
      updateDoctor(info) {
        this.condition.orderDoctorID = info ? info.id : null
      },
      updateDate(info, column) {
        this.condition[column] = info
      },
      resetSearch() {
        this.condition.st = twoWeeksAgo
        this.condition.et = today
        this.condition.accNo = null
        this.condition.patientID = null
        this.condition.orderDoctorID = null
      },
      changeSort (column) {
        if(column===''){return;}
        if (this.pagination.title === column) {
          this.pagination.order = !this.pagination.order
        } else {
          this.pagination.title = column
          this.pagination.order = false
        }
        this.$store.dispatch('examinations/sortExaminationSearchResult', {title:column,order:this.pagination.order})

      },
      clickAddExamination(){
        this.dialog = true;
      },
      close(){
        this.dialog = false;
      },
      initDate () {
        if (!this.getExaminationInfos) {
          return 
        }
        const len = this.getExaminationInfos.length
        this.dateMenus = this.createArrayWithSameValue(len, false)
      },
      createArrayWithSameValue: (size, item) => Array(size).fill(item),
      updateExamination ( examinationID, field, value ) {
        for(let i=0;i<this.dateMenus.length;i++){
          this.dateMenus[i] = false
        }

        const updateObj = {
          examinationID: examinationID,
          field: field,
          value: value
        }
        
        this.$store.dispatch('examinations/updateColumnById', updateObj)
          .then(res => {
            if (res && !res.success) {
              this.message = res.err.msg
              this.snackbar = true
            } else {
              this.message = null
              this.snackbar = false
            }
            this.search()
        });
      },

      async addExamination () {
        var validateResult = true;
        if (this.editedItem.accNo == '') {
          validateResult = false;
          this.accNoLabel = 'inline';
        } else {
          this.accNoLabel = 'none';
        }
        if (this.editedItem.patientID == '') {
          validateResult = false;
          this.patientIDLabel = 'inline';
        } else {
          this.patientIDLabel = 'none';
        }
        if (this.editedItem.date == '') {
          validateResult = false;
          this.dateLabel = 'inline';
        } else {
          this.dateLabel = 'none';
        }
        if (this.editedItem.orderDoctorID == '') {
          validateResult = false;
          this.orderDoctorIDLabel = 'inline';
        } else {
          this.orderDoctorIDLabel = 'none';
        }
        if (this.editedItem.examination_typeID == '') {
          validateResult = false;
          this.examination_typeIDLabel = 'inline';
        } else {
          this.examination_typeIDLabel = 'none';
        }
        if (validateResult) {
          try {
            let obj = {            
              accNo : this.editedItem.accNo,
              patientID : this.editedItem.patientID,
              date : this.editedItem.date,
              orderDoctorID : this.editedItem.orderDoctorID,
              examination_typeID : this.editedItem.examination_typeID
            }

            await this.$store.dispatch('examinations/addExamination', obj)
              .then(res => {
                if (res && !res.success) {
                  this.errorMessage = res.err.msg
                } else {
                  this.errorMessage = null
                  this.dialog = false;
                  this.search()
                }
              });
          } catch (e) {
            console.log(e)
            this.dialog = false;
          }
        }
      },
      clickItem(data){
        this.tempItem = Object.assign({}, data);
      }
    }
  }
</script>

<style lang="scss">
.search-container{
  button {
    margin-top: 30px;
  }
}
.err-msg {
  padding-left: 3px;
}

// Solve: [Chrome] Unable to preventDefault inside passive event listener due to target being treated as passive.
.owl-carousel {
-ms-touch-action: pan-y;
touch-action: pan-y;
}

.hint{
  font-size:12px;
  color: rgba(0,0,0,.54);
  p {
    margin: -12px 0 0 0;
  }
  b {
    color:#007FFF;
  }
}
</style>